<template>
    <div class="floating-help-button">
        <VBtn
            icon="mdi-help"
            size="large"
            color="primary"
            elevation="8"
            @click="showSupportPopUp()"
        />
    </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { createPopup } from "@formcrafts/embed";
import { usePiniaStore } from "@/plugins/store";

const pStore = usePiniaStore();

const supportForm = createPopup({
    form: import.meta.env.VITE_FORMCRAFTS_APP_ID,
    width: 500,
    redirectWithin: true,
    values: {},
});

const showSupportPopUp = async () => {
    if (pStore.getEmailAddress !== null) {
        supportForm.values({
            field3: pStore.getEmailAddress,
        });
    }
    supportForm.open();
};

onMounted(() => {
    supportForm.load();
});
</script>

<style scoped>
.floating-help-button {
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 1000;
}
</style>
